import React from "react";
import businessImg from "../../assets/images/webp/driving-business-img.webp";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";
import { DRIVING_BUSINESS_LIST } from "../../utils/defaults";
import Icons from "../common/components/Icons";
import FlipCard from "../common/components/FlipCard";
const BusinessSuccess = () => {
  return (
    <div className="w-full pb-14 sm:pb-16 md:pb-24 lg:pb-28 xl:pb-[140px]">
      <div className="container mx-auto flex items-center justify-between w-full max-xl:flex-col-reverse max-xl:gap-8 max-md:mx-0">
        <div className="relative w-fit">
          <div className="w-full absolute top-0 left-0 h-full">
            <FlipCard imageUrl={businessImg}></FlipCard>
          </div>
          <img
            className="w-full max-w-[584px] max-lg:max-w-[480px] max-md:mr-auto opacity-0 pointer-events-none"
            src={businessImg}
            alt="business img"
          />
        </div>
        <div className="xl:max-w-[490px] 2xl:max-w-[550px] ">
          <BlueTag>Driving Business Success</BlueTag>
          <Heading className="max-lg:max-w-[550px] pt-1">
            We create unique business solutions that drive success
          </Heading>
          <Paragraph className="mt-3">
            At Makeway India, we specialize in turning innovative ideas into
            real-world solutions. With a deep understanding of your business
            needs, we craft personalized strategies that not only help you grow
            but also set you apart from competitors in your industry.
          </Paragraph>
          <div className="inline-flex flex-col gap-y-4 pt-5 pb-4 md:pb-6 ">
            {DRIVING_BUSINESS_LIST.map((obj, index) => (
              <div key={index} className="inline-flex items-center  gap-x-1.5">
                <Icons className="min-w-[18px]" icon="blue-check-mark" />
                <p className="font-semibold text-sm !leading-130 text-custom-dark-blue">
                  {obj}
                </p>
              </div>
            ))}
          </div>
          <h3 className="font-bold !leading-150 text-base md:text-lg text-custom-dark-blue sm:max-w-[768px] xl:max-w-[421px]">
            Our average rating of 4.8 makes us one of the most trusted business
            organizations worldwide.
          </h3>
        </div>
      </div>
    </div>
  );
};

export default BusinessSuccess;
